var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { fluid: "" } },
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            [
              _c("FormBlogCategory", {
                attrs: {
                  loading: _vm.isFormLoading,
                  disabled: _vm.isMutationLoading,
                  data: _vm.blogCategory,
                  isNew: !_vm.id,
                  language: _vm.language,
                },
                on: {
                  submit: _vm.formBlogCategorySubmit,
                  "delete-blog-category": _vm.deleteBlogCategory,
                  "language-update": function ($event) {
                    _vm.language = $event
                  },
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c("ConfirmationDialog", {
        ref: "confirmBlogCategoryRemoving",
        attrs: { confirmText: "Удалить" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }